import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const DataServices = lazy(() =>
  import("@scenes/DataServices").then((module) => ({
    default: module.DataServices,
  }))
);

export const lookerDataPointsNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("billing-subscriptions-total-data-points-usage", "Total Data Points Usage"),
  pageNameForTracking: () => "Total Data Points Usage",
  Component: DataServices,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  getDeveloperNavigationAllowed: ({ hasPermission, featureOn }) => {
    // Please keep parity with the same conditional in sections/company_settings/subscriptions_and_billing-section.ko.js.coffee
    const notUsingRateLimitedPricingModel = !featureOn("rate_limit_pricing_model_entitlement");
    return (
      notUsingRateLimitedPricingModel &&
      hasPermission("appGroup", {
        permission: "viewBilling",
      })
    );
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("billing-subscriptions-total-data-points-usage-alt-keyword-1", "Contract Details"),
        t("billing-subscriptions-total-data-points-usage-alt-keyword-2", "Data Point Usage"),
        t("billing-subscriptions-total-data-points-usage-alt-keyword-3", "Billing Cycle"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
